import { reaction } from 'mobx'
import { openNotificationLink } from 'utils'
import BaseHub from './baseHub'

export default class MainHub extends BaseHub {
  constructor(rootStore) {
    super('general', rootStore)
    this.rootStore = rootStore

    reaction(
      () => this.rootStore.authStore.accessToken,
      () => {
        if (!this.rootStore.authStore.accessTokenExpired) this.beginConnection()
        // this.disconnect()
      }
    )

    if (this.rootStore.authStore.accessToken && !this.rootStore.authStore.accessTokenExpired)
      this.beginConnection()
  }

  configureHub() {
    super.configureHub()
    this.connection.on('AreaAdded', (area) => {
      this.rootStore.areaStore.addOne(area)
    })

    this.connection.on('AreaUpdated', (area) => {
      this.rootStore.areaStore.updateOne(area)
    })

    this.connection.on('AreaRemoved', (areaId) => {
      this.rootStore.areaStore.removeOne(areaId)
    })

    this.connection.on('WorkStationAdded', (workStation) => {
      this.rootStore.workStationStore.addOne(workStation)
    })

    this.connection.on('WorkStationUpdated', (workStation) => {
      this.rootStore.workStationStore.updateOne(workStation)
    })

    this.connection.on('WorkStationRemoved', (workStationId) => {
      this.rootStore.workStationStore.removeOne(workStationId)
    })

    this.connection.on('NotificationCreated', (notification) => {
      if (!this.shouldHandleNotification(notification)) return

      const isNewNotification = this.rootStore.notificationStore.prepend(notification)
      if (isNewNotification)
        this.rootStore.toastMiddleware.notify({
          type: notification.type || 'info',
          title: notification.title,
          description: notification.description,
          actionLabel: notification.actionLink ? 'Abrir' : undefined,
          onAction: notification.actionLink
            ? () => openNotificationLink(notification.actionLink)
            : undefined,
          position: 'top-left',
          sound: true,
        })
    })
  }

  shouldHandleNotification(notification) {
    const { authStore } = this.rootStore
    if (!notification) return false
    if (notification.tenantId && notification.tenantId !== authStore.selectedTenant) {
      return false
    }

    const matchesUserId =
      notification.userId !== undefined &&
      notification.userId !== null &&
      authStore.currentUserId !== undefined &&
      notification.userId === authStore.currentUserId

    const matchesEmail =
      notification.email &&
      authStore.email &&
      notification.email.toLowerCase() === authStore.email.toLowerCase()

    return matchesUserId || matchesEmail
  }

  addArea(area) {
    this.connection && this.connection.invoke('AddArea', area)
  }

  updateArea(area) {
    this.connection && this.connection.invoke('UpdateArea', area)
  }

  removeArea(area) {
    this.connection && this.connection.invoke('RemoveArea', area)
  }

  addWorkStation(workStation) {
    this.connection && this.connection.invoke('AddWorkStation', workStation)
  }

  updateWorkStation(workStation) {
    this.connection && this.connection.invoke('UpdateWorkStation', workStation)
  }

  removeWorkStation(workStation) {
    this.connection && this.connection.invoke('RemoveWorkStation', workStation)
  }
}
